import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UiDatepickerComponent } from './datepicker/datepicker.component';
import { UiDaterangeComponent } from './daterange/daterange.component';
import { UiDropdownComponent } from './dropdown/dropdown.component';
import { UiModalComponent } from './modal/modal.component';

@NgModule({
  declarations: [UiDatepickerComponent, UiDaterangeComponent, UiDropdownComponent, UiModalComponent],
  imports: [CommonModule, FormsModule],
  exports: [UiDatepickerComponent, UiDaterangeComponent, UiDropdownComponent, UiModalComponent]
})
export class UiKitModule {}
